// The booking calendar currently offers deliveries Monday through Friday.
export const parisToday = (reference = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(reference);
  const part = name => Number(parts.find(p => p.type === name).value);
  return new Date(part('year'), part('month') - 1, part('day'));
};

export const nextWorkingDeliveryDay = (reference = new Date()) => {
  const day = parisToday(reference);
  do { day.setDate(day.getDate() + 1); } while ([0, 6].includes(day.getDay()));
  return day;
};

export const firstStandardDeliveryDay = (reference = new Date()) => {
  const day = nextWorkingDeliveryDay(reference);
  const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: '2-digit', hourCycle: 'h23' }).format(reference));
  if (hour >= 16) {
    do { day.setDate(day.getDate() + 1); } while ([0, 6].includes(day.getDay()));
  }
  return day;
};

export const isExpressAllowed = (date, reference = new Date()) => {
  if (!date) return true;
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return ![0, 6].includes(day.getDay()) && day >= parisToday(reference) && day <= nextWorkingDeliveryDay(reference);
};

export const DELIVERY_SLOTS = ['8h-12h', '12h-16h', '8h-16h'];

export const canModifyDelivery = (date, slot, reference = new Date()) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '')) return false;
  const [year, month, day] = date.split('-').map(Number);
  const match = (slot || '').match(/(\d{1,2})\s*(?:h|:)\s*(\d{2})?/);
  const hour = match ? Number(match[1]) : 8;
  const minute = match ? Number(match[2] || 0) : 0;
  if (hour > 23 || minute > 59) return false;
  const wall = Date.UTC(year, month - 1, day, hour, minute);
  let instant = wall;
  for (let i = 0; i < 2; i++) {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(instant));
    const n = key => Number(parts.find(p => p.type === key).value);
    const offset = Date.UTC(n('year'), n('month') - 1, n('day'), n('hour'), n('minute'), n('second')) - instant;
    instant = wall - offset;
  }
  return instant - reference.getTime() >= 24 * 60 * 60 * 1000;
};
